{
  "fr": {
    "issue_status": {
      "actions": {
        "create": "Créer un statut de problème"
      },
      "labels": {
        "backup_status": "Statut de remplacement",
        "customer_status": "Le client verra",
        "delete_status": "Supprimer le statut \"{name}\" ?",
        "delete_status_disclaimer": "Tous les éléments de SAV avec ce statut seront réassignés au statut que vous sélectionnez ci-dessous.",
        "inbox_hint": "Statut par défaut pour la boîte de réception client",
        "internal_status": "Statut interne",
        "new_issue_status": "Statut"
      }
    }
  }
}